<template>
  <div class="lav-status-container">
    <custom-skeleton-loader :LoadingFlag="SkeletonLoadingFlag" />
    <div v-if="!SkeletonLoadingFlag" class="status-content">
      <!-- President Date -->
      <div class="status-row">
        <div class="row-icon">
          <v-icon>mdi-calendar-multiple</v-icon>
        </div>
        <div class="row-content">
          <div class="row-label">President Date</div>
          <div v-if="Records.LavDateFlag" class="row-value-chip">
            <v-chip small color="#ec407a" text-color="white">
              {{ Records.LavDateTxt }}
            </v-chip>
          </div>
          <v-btn
            v-else
            small
            class="select-date-btn"
            @click.prevent="clickPresidentDate()"
          >
            <v-icon left>mdi-calendar-plus</v-icon>
            Select Date
          </v-btn>
        </div>
      </div>

      <!-- President Approval Status -->
      <div class="status-row">
        <div class="row-icon">
          <v-icon>mdi-shield-check</v-icon>
        </div>
        <div class="row-content">
          <div class="row-label">President Approval Status</div>
          <v-chip
            small
            :color="Records.VerificationStatusColor"
            text-color="white"
          >
            {{ Records.VerificationStatusTxt }}
          </v-chip>
        </div>
      </div>

      <!-- ZVP Date -->
      <div class="status-row">
        <div class="row-icon">
          <v-icon>mdi-calendar-star</v-icon>
        </div>
        <div class="row-content">
          <div class="row-label">ZVP Date</div>
          <div class="row-value">
            {{ Records.ZvpLavDate || "Not scheduled" }}
          </div>
        </div>
      </div>

      <!-- LAV Status -->
      <div class="status-row">
        <div class="row-icon">
          <v-icon>mdi-checkbox-marked-circle</v-icon>
        </div>
        <div class="row-content">
          <div class="row-label">Second Half Status</div>
          <v-chip
            small
            :color="
              Records.CompletedStatusColor
                ? Records.CompletedStatusColor
                : '#d5cfac'
            "
            text-color="white"
          >
            {{
              Records.CompletedStatusTxt
                ? Records.CompletedStatusTxt
                : "Yet to wait"
            }}
          </v-chip>
        </div>
      </div>

      <!-- NHQ Approval Status -->
      <div class="status-row">
        <div class="row-icon">
          <v-icon>mdi-check-all</v-icon>
        </div>
        <div class="row-content">
          <div class="row-label">NHQ Approval Status</div>
          <v-chip
            small
            :color="
              Records.LavNhqApprovalStatusColor
                ? Records.LavNhqApprovalStatusColor
                : '#d5cfac'
            "
            text-color="white"
          >
            {{
              Records.LavNhqApprovalStatusTxt
                ? Records.LavNhqApprovalStatusTxt
                : "Yet to wait"
            }}
          </v-chip>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <v-btn
          v-if="Records.ApprovalFlag"
          @click.prevent="approvedStatus()"
          class="approval-btn"
        >
          <v-icon left>mdi-shield-check</v-icon>
          President Approval
        </v-btn>

        <v-btn
          v-if="Records.DownloadFlag"
          :href="Records.FilePath"
          target="_blank"
          class="download-btn"
        >
          <v-icon left>mdi-file-pdf-box</v-icon>
          Download Report
        </v-btn>
      </div>
      <v-dialog v-model="presidentDatePrompt" persistent max-width="75%">
        <lom-training-date
          pageTitle="President Date"
          pageDescription="President Date"
          :presidentDatePrompt="presidentDatePrompt"
          @hideDialog="hidepresidentDatePrompt($event)"
          :recordData="rowData"
          v-if="presidentDatePrompt"
        ></lom-training-date>
      </v-dialog>
      <v-dialog v-model="lomInformationStatus" persistent max-width="75%">
        <lom-training-approval
          pageTitle="President Date"
          pageDescription="President Date"
          :lomInformationStatusPrompt="lomInformationStatusPrompt"
          @hideDialog="hidelomInformationStatusPrompt($event)"
          :recordData="selectedData"
          v-if="lomInformationStatus"
        ></lom-training-approval>
      </v-dialog>
    </div>
  </div>
</template>
       
<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import VotingCount from "@/view/pages/erp/lom/lom-information/VotingCount.vue";
import LomTrainingDate from "@/view/pages/erp/lom/lom-information/LomTrainingDate.vue";
import LomTrainingApproval from "@/view/pages/erp/lom/lom-information/LomTrainingApproval.vue";
import LdmtStatus from "@/view/pages/erp/lom/lom-information/LdmtStatus.vue";

export default {
  mixins: [common],
  components: {
    LomTrainingDate,
    LomTrainingApproval,
    LdmtStatus,
  },
  data() {
    return {
      VotingRightsStatus: "",
      DocumentPath: "",
      uploadDocumentPrompt: false,
      EditRecordPrompt: false,
      presidentDatePrompt: false,
      lomInformationStatus: false,

      SkeletonLoadingFlag: true,

      EligibleCount: 0,
      selectedData: {},
      VotingData: {},

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      records: {},
      Records: {},
      LdmtDate: {},
      Records: {},
    };
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        var server_url = companyConfig.apiURL;
        console.log("server_url = " + server_url);
        var SampleFilePath = server_url + "assets/sample/voting_rights.pdf";
        console.log("SampleFilePath = " + SampleFilePath);
        this.SampleFilePath = SampleFilePath;
      }
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "voting_rights",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.pageData();
    },
    pageData() {
      console.log("pageData called");
      this.getTableRecords();
    },
    clickPresidentDate() {
      console.log("clickDate called");
      var tr = this.Records;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        this.presidentDatePrompt = true;
        this.rowData = tr;
      } else {
        var message = "Selected Date failed";
        this.toast("error", message);
      }
    },
    approvedStatus() {
      console.log("clickDate called");
      var tr = this.Records;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.lomInformationStatus = true;
        this.selectedData = tr;
      } else {
        var message = "Votingdescription failed";
        this.toast("error", message);
      }
    },
    hidepresidentDatePrompt(flag) {
      console.log("hidepresidentDatePrompt called");
      this.presidentDatePrompt = false;
      console.log({ flag });
      if (flag) {
        this.pageData();
      }
    },
    hidelomInformationStatusPrompt(flag) {
      console.log("hidelomInformationStatusPrompt called");
      this.lomInformationStatus = false;
      console.log({ flag });
      if (flag) {
        this.pageData();
      }
    },
    hideUploadRecordPrompt() {
      console.log("hideUploadRecordPrompt called");
      this.uploadDocumentPrompt = false;
      this.pageData();
    },
    editData() {
      console.log("editData called");
      var tr = this.VotingData;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        this.EditRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Selected Date failed";
        this.toast("error", message);
      }
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var LomCode = this.$session.get("LomId");
      LomCode = LomCode == (null || undefined) ? 0 : LomCode;
      console.log("LomCode=" + LomCode);

      // var validate1 = this.$refs.form2.validate();
      var validate1 = true;
      console.log("validate1=" + validate1);

      if (validate1) {
        this.TrainingData = {};

        this.SkeletonLoadingFlag = true;
        this.rows = [];
        this.zone = {};
        this.lom = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-training/status-info";
        var upload = {
          UserInterface: 2,
          // LomCode: LomCode,
          // Category: 1,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SkeletonLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.Records = response.data.records;
              console.log("Records=" + JSON.stringify(thisIns.Records));
              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SkeletonLoadingFlag = false;
          });
      }
    },
  },
  mounted() {},
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
.lav-status-container {
  width: 100%;

  .status-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .status-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    background: linear-gradient(
      135deg,
      rgba(236, 64, 122, 0.05) 0%,
      rgba(229, 57, 53, 0.03) 100%
    );
    border-radius: 10px;
    border-left: 3px solid #ec407a;
    transition: all 0.3s ease;

    &:hover {
      background: linear-gradient(
        135deg,
        rgba(236, 64, 122, 0.1) 0%,
        rgba(229, 57, 53, 0.08) 100%
      );
      transform: translateX(4px);
    }
  }

  .row-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: linear-gradient(135deg, #ec407a 0%, #e91e63 100%);
    border-radius: 8px;
    color: white;
    font-size: 18px;
  }

  .row-content {
    flex: 1;
  }

  .row-label {
    font-size: 11px;
    font-weight: 600;
    color: #666;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
  }

  .row-value {
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }

  .row-value-chip {
    display: flex;
    align-items: center;
    gap: 8px;

    .v-chip {
      font-weight: 600 !important;
    }
  }

  .select-date-btn {
    background: linear-gradient(135deg, #ec407a 0%, #e91e63 100%) !important;
    color: white !important;
    padding: 6px 12px !important;
    border-radius: 6px !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.4px !important;
    transition: all 0.3s ease !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(236, 64, 122, 0.3);
    }
  }

  .action-buttons {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 12px;
    padding: 16px;
    background: linear-gradient(
      135deg,
      rgba(236, 64, 122, 0.08) 0%,
      rgba(229, 57, 53, 0.05) 100%
    );
    border-radius: 10px;
  }

  .approval-btn,
  .download-btn {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    transition: all 0.3s ease !important;
    flex: 1;
    min-width: 150px;
  }

  .approval-btn {
    background: linear-gradient(135deg, #ec407a 0%, #e91e63 100%) !important;
    color: white !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(236, 64, 122, 0.3);
    }
  }

  .download-btn {
    background: linear-gradient(135deg, #ef5350 0%, #f44336 100%) !important;
    color: white !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(244, 67, 54, 0.3);
    }
  }
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
